import { forwardRef, type ReactNode } from 'react'
import type { TypographyProps } from '@mui/material'
import { ExternalAppLayout } from 'routes/components/ExternalAppLayout/ExternalAppLayout'
import * as $ from './TextPage.styled'

interface TextPageProps {
  title: string
  children: ReactNode
  paperProps?: TypographyProps
}

export const TextPage = forwardRef<HTMLDivElement, TextPageProps>(({ title, children, paperProps }, ref) => (
  <ExternalAppLayout ref={ref}>
    <$.Container disableGutters={true} maxWidth={false}>
      <$.Title variant="h3" color="primary">
        {title}
      </$.Title>
      <$.Paper component="div" {...paperProps}>
        {children}
      </$.Paper>
    </$.Container>
  </ExternalAppLayout>
))

TextPage.displayName = 'TextPage'
